import React from "react";
import { GraduationCap, ArrowRight, ShieldCheck, Award } from "lucide-react";

/* Banner accattivante che invita a scoprire i corsi di formazione.
   Posizionato subito dopo Hero, prima di About.
   Click sul banner -> scroll alla sezione #corsi sotto il Preventivo. */
export const TrainingBanner = () => {
    const scrollToCorsi = (e) => {
        e.preventDefault();
        const el =
            document.getElementById("training-form") ||
            document.getElementById("corsi");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            data-testid="training-banner"
            className="relative bg-white overflow-hidden"
        >
            <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-14 py-10 lg:py-14">
                <div className="bg-gradient-to-br from-nsp-yellow-50 via-white to-nsp-green-50 rounded-3xl border border-nsp-yellow/30 shadow-lg shadow-nsp-yellow/20 overflow-hidden relative">
                    {/* Decorative glow */}
                    <div
                        aria-hidden="true"
                        className="absolute -top-20 -right-20 w-72 h-72 bg-nsp-yellow-100 rounded-full blur-3xl opacity-70"
                    />
                    <div
                        aria-hidden="true"
                        className="absolute -bottom-20 -left-20 w-72 h-72 bg-nsp-green-100 rounded-full blur-3xl opacity-70"
                    />

                    <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center p-8 lg:p-12">
                        {/* Icona grande */}
                        <div className="lg:col-span-2 flex justify-center lg:justify-start">
                            <div className="relative">
                                <div className="relative w-20 h-20 lg:w-24 lg:h-24 bg-gradient-to-br from-nsp-green to-nsp-green-800 rounded-3xl flex items-center justify-center shadow-xl shadow-nsp-green/30">
                                    <GraduationCap className="w-10 h-10 lg:w-12 lg:h-12 text-nsp-yellow" strokeWidth={2} />
                                </div>
                                <div className="absolute -top-2 -right-2 bg-nsp-yellow text-nsp-green text-[9px] font-bold uppercase tracking-widest px-2 py-1 rounded-full shadow-md">
                                    NEW
                                </div>
                            </div>
                        </div>

                    {/* Testo */}
                    <div className="lg:col-span-7 text-center lg:text-left">
                        <div className="inline-flex items-center gap-2 bg-nsp-green text-nsp-yellow px-3 py-1.5 mb-3 text-[10px] font-bold uppercase tracking-[0.3em]">
                            <ShieldCheck className="w-3 h-3" />
                            Formazione professionale
                        </div>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-nsp-green leading-[0.95] tracking-tighter">
                            Vuoi guidare i mezzi
                            <br />
                            in <span className="bg-nsp-green text-nsp-yellow px-2">cantiere?</span>
                        </h2>
                        <p className="mt-4 text-nsp-green text-sm sm:text-base max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                            <b>Ottieni il patentino</b> per escavatori, caricatori frontali, terne, gru per scarrabili e ponteggi.
                            <br className="hidden sm:block" />
                            Corsi a norma <b>D.Lgs. 81/08</b> con attestato e abilitazione riconosciuta.
                        </p>

                        {/* Badge mini */}
                        <div className="mt-5 flex flex-wrap gap-2 justify-center lg:justify-start">
                            <Pill icon={Award}>Attestato riconosciuto</Pill>
                            <Pill icon={ShieldCheck}>D.Lgs. 81/08</Pill>
                            <Pill icon={GraduationCap}>3 corsi attivabili</Pill>
                        </div>
                    </div>

                    {/* CTA pulsante */}
                    <div className="lg:col-span-3 flex justify-center lg:justify-end">
                        <button
                            data-testid="training-banner-cta"
                            onClick={scrollToCorsi}
                            className="group relative rounded-full bg-nsp-green text-nsp-yellow px-7 py-5 sm:px-9 sm:py-6 font-bold uppercase tracking-widest text-sm hover:bg-nsp-green-dark transition-all shadow-2xl hover:shadow-[0_25px_60px_-10px_rgba(10,59,37,0.5)] hover:-translate-y-0.5 flex items-center gap-3"
                            aria-label="Scopri i corsi di formazione"
                        >
                            <span>Scopri i corsi</span>
                            <span className="w-9 h-9 bg-nsp-yellow text-nsp-green flex items-center justify-center group-hover:translate-x-1 transition-transform">
                                <ArrowRight className="w-4 h-4" strokeWidth={3} />
                            </span>
                        </button>
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
};

const Pill = ({ icon: Icon, children }) => (
    <span className="inline-flex items-center gap-1.5 bg-white text-nsp-green text-[11px] font-bold uppercase tracking-wider px-3 py-1.5 border border-nsp-green/20">
        <Icon className="w-3 h-3" />
        {children}
    </span>
);

export default TrainingBanner;
